import Icon from '../components/Icon.vue'

Icon.register({
  'check-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504.5 171.9L468.3 135.5C458.3 125.5 442.1 125.5 432.1 135.5L192 377 79.9 264.3C69.9 254.2 53.7 254.2 43.7 264.3L7.5 300.7C-2.5 310.7-2.5 327.1 7.5 337.1L173.9 504.5C183.9 514.5 200.1 514.5 210.1 504.5L504.5 208.4C514.5 198.3 514.5 182 504.5 171.9zM166.6 282.7C173.4 289.7 184.8 289.7 191.8 282.9L403.9 72.6C410.9 65.8 410.9 54.4 404 47.4L362.1 5.3C355.2-1.7 343.9-1.7 336.9 5.1L179.7 161.2 111.5 92.4C104.6 85.4 93.3 85.4 86.3 92.2L44.1 134C37.1 140.9 37.1 152.2 44 159.2L166.6 282.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/check-double.js
// module id = 4NbK
// module chunks = 144